import React, { useContext, useEffect, useState } from "react";
import { db } from "../firebase"; // Tu ruta real a la configuración de Firebase
import { doc, onSnapshot, setDoc } from "firebase/firestore";
import '../css/Temporizador.css';
import { AuthContext } from "../context/auth.context";

export default function Temporizador() {
  const { isAdmin } = useContext(AuthContext);

  // Fecha de inicio del reto: 12 de Junio de 2026 a las 08:00
  const targetDate = new Date(2026, 5, 12, 8, 0, 0); 
  
  // 📁 NUEVA REFERENCIA: Colección 'configFechaFin', Documento 'reto' (o el ID que le hayas puesto)
  // Si le pusiste otro ID al documento en lugar de 'reto', cámbialo aquí abajo:
  const retoDocRef = doc(db, "configFechaFin", "reto");

  // Estados del componente
  const [timeLeft, setTimeLeft] = useState({ months: 0, days: 0, hours: 0, minutes: 0 });
  const [chronoTime, setChronoTime] = useState({ days: "0", hours: "0", minutes: "0", seconds: "0" });
  const [isRetoStarted, setIsRetoStarted] = useState(false);
  const [fechaFinDb, setFechaFinDb] = useState(null); 

  // 🕒 TU LÓGICA ORIGINAL DE CUENTA ATRÁS (Intacta)
  const calculateTimeLeft = () => {
    const now = new Date();
    if (now >= targetDate) return { months: 0, days: 0, hours: 0, minutes: 0 };

    let months = (targetDate.getFullYear() - now.getFullYear()) * 12 + (targetDate.getMonth() - now.getMonth());
    const tempMonthDate = new Date(now);
    tempMonthDate.setMonth(tempMonthDate.getMonth() + months);
    if (tempMonthDate > targetDate) {
      months--;
      tempMonthDate.setMonth(tempMonthDate.getMonth() - 1);
    }

    const remainingMs = targetDate - tempMonthDate;
    const totalMinutes = Math.floor(remainingMs / 1000 / 60);
    const days = Math.floor(totalMinutes / (60 * 24));
    const hours = Math.floor((totalMinutes % (60 * 24)) / 60);
    const minutes = totalMinutes % 60;

    return { months, days, hours, minutes };
  };

  // 🚴‍♂️ LÓGICA DEL CRONÓMETRO (Acepta congelar el tiempo si viene de la DB)
  const calculateChronometer = (endTime = null) => {
    const end = endTime ? new Date(endTime) : new Date();
    const remainingMs = end - targetDate;
    
    if (remainingMs < 0) return { days: "0", hours: "0", minutes: "0", seconds: "0" };

    const totalSeconds = Math.floor(remainingMs / 1000);
    const totalMinutes = Math.floor(totalSeconds / 60);
    const totalHours = Math.floor(totalMinutes / 60);
    
    const days = Math.floor(totalHours / 24);
    const hours = totalHours % 24;
    const minutes = totalMinutes % 60;
    const seconds = totalSeconds % 60;

    return {
      days: String(days).padStart(1, "0"),
      hours: String(hours).padStart(1, "0"),
      minutes: String(minutes).padStart(1, "0"),
      seconds: String(seconds).padStart(1, "0")
    };
  };

  // 📡 EFFECT 1: Escuchar la nueva colección en tiempo real
  useEffect(() => {
    const unsubscribe = onSnapshot(retoDocRef, (docSnap) => {
      if (docSnap.exists() && docSnap.data().fechaFin) {
        const finData = docSnap.data().fechaFin;
        // Controlamos si viene como Timestamp de Firebase o como String ISO
        setFechaFinDb(finData.seconds ? new Date(finData.seconds * 1000) : new Date(finData));
      } else {
        setFechaFinDb(null);
      }
    });

    return () => unsubscribe();
  }, []);

  // ⏳ EFFECT 2: Bucle del contador / cronómetro en vivo
  useEffect(() => {
    const timer = setInterval(() => {
      const now = new Date();
      const started = now >= targetDate;
      setIsRetoStarted(started);

      if (fechaFinDb) {
        // Si hay fecha de fin en la BD, muestra el tiempo congelado de la hazaña
        setChronoTime(calculateChronometer(fechaFinDb));
      } else if (started) {
        // Si el reto ha empezado y sigue activo, corre en vivo
        setChronoTime(calculateChronometer(null));
      } else {
        // Cuenta atrás previa al inicio
        setTimeLeft(calculateTimeLeft());
      }
    }, 1000);

    return () => clearInterval(timer);
  }, [fechaFinDb]);


  // 💾 FUNCIONES DE ADMINISTRACIÓN CON SETDOC (EVITA ERRORES DE DOCUMENTO NO ENCONTRADO)
  const handleStopReto = async () => {
    try {
      const isoStringNow = new Date().toISOString();
      // Guardamos la fecha exacta del clic sin machacar otros campos que tengas gracias a merge:true
      await setDoc(retoDocRef, {
        fechaFin: isoStringNow 
      }, { merge: true });
    } catch (error) {
      console.error("Error al detener el cronómetro: ", error);
    }
  };

  // const handleResetReto = async () => {
  //   try {
  //     // Devolvemos el campo a null para que el cronómetro vuelva a correr en vivo
  //     await setDoc(retoDocRef, {
  //       fechaFin: null 
  //     }, { merge: true });
  //   } catch (error) {
  //     console.error("Error al resetear el cronómetro: ", error);
  //   }
  // };


  // 🔀 RENDERS CONDICIONALES

  // VISTA 1: El reto está activo o ya ha sido completado
  if (isRetoStarted || fechaFinDb) {
    return (
      <div className="temporizador-container">
        {/* Cambia el texto automáticamente según la base de datos */}
        <h2 className="temporizador-title">
          {fechaFinDb ? "¡¡HAZAÑA COMPLETADA EN!!" : "¡¡EL RETO ESTÁ EN MARCHA!!"}
        </h2>
  
        <div className="temporizador-grid">
          <div className="temp-box">
            <div className="temp-number">{chronoTime.days}</div>
            <div className="temp-label">DÍAS</div>
          </div>
          <div className="temp-box">
            <div className="temp-number">{chronoTime.hours}</div>
            <div className="temp-label">HORAS</div>
          </div>
          <div className="temp-box">
            <div className="temp-number">{chronoTime.minutes}</div>
            <div className="temp-label">MINUTOS</div>
          </div>
          <div className="temp-box">
            <div className="temp-number">{chronoTime.seconds}</div>
            <div className="temp-label">SEGUNDOS</div>
          </div>
        </div>

        {/* 🔐 PANEL ADMIN */}
        {isAdmin && (
          <div className="admin-controls">
            {!fechaFinDb ? (
              <button className="btn-admin btn-stop" onClick={handleStopReto}>
                🛑 PARAR CRONÓMETRO
              </button>
            ) : (
              <span className="badge-finalizado">Tiempo registrado con éxito</span>
            )}
            
            {/* <button className="btn-admin btn-reset" onClick={handleResetReto}>
              🔄 RESETEAR CRONÓMETRO (LOCAL/DEV)
            </button> */}
          </div>
        )}
      </div>
    );
  }

  // VISTA 2: Cuenta atrás clásica (Antes del inicio del reto)
  return (
    <div className="temporizador-container">
      <h2 className="temporizador-title">EL RETO COMENZARÁ!!</h2>

      <div className="temporizador-grid">
        <div className="temp-box">
          <div className="temp-number">{timeLeft.months}</div>
          <div className="temp-label">MES</div>
        </div>
        <div className="temp-box">
          <div className="temp-number">{timeLeft.days}</div>
          <div className="temp-label">DÍAS</div>
        </div>
        <div className="temp-box">
          <div className="temp-number">{timeLeft.hours}</div>
          <div className="temp-label">HORAS</div>
        </div>
        <div className="temp-box">
          <div className="temp-number">{timeLeft.minutes}</div>
          <div className="temp-label">MINUTOS</div>
        </div>
      </div>
      
      {/* Botón de reset visible para forzar pruebas previas si lo necesitas */}
      {/* {isAdmin && (
        <div className="admin-controls">
          <button className="btn-admin btn-reset" onClick={handleResetReto}>
            🔄 RESETEAR / ABRIR RETO
          </button>
        </div>
      )} */}
    </div>
  );
}